var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-4 px-4 grid grid-cols-8"},[_c('p',{staticClass:"grid col-start-3 col-span-4 text-white text-sm md:text-sm font-extralight text-center"},[_vm._v(" "+_vm._s(_vm.$t('onboardingHeader.description'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }